/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useClusterPlanStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '70%',
  },
  stepTitleBlock: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    justifyContent: 'space-between',
  },
  stepTitle: {
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 'bold',
  },
  specsOffset: {
    marginBottom: '23px',
  },
  subtotals: {
    marginTop: '20px',
  },
  subtotalLine: {
    color: '#000000',
    fontSize: '16px',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '8px 0',
  },
  totalLine: {
    position: 'relative',
    color: '#F16623',
    fontSize: '20px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 500,
    paddingTop: '25px',
    marginTop: '20px',

    '&:before': {
      content: "''",
      position: 'absolute',
      display: 'block',
      top: 0,
      left: 0,
      right: '100%',
      width: '100%',
      height: '1px',
      background: '#F6F7F8',
      borderRadius: '0.5px',
    },
  },
  settingsIcon: {
    marginLeft: '8px',
    color: '#A2A7AE',
    width: '24px',
    height: '24px',
    padding: '0',
    '&:hover': {
      color: '#BDC1C6',
    },
  },
}));
